// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const Pagination = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    p {
      display: none;
    }
    div {
      flex-direction: row;
      gap: 24px;

      button {
        width: auto;
        height: auto;
        background-color: ${
          isDark ? theme.colors.base.main : theme.colors.white
        };
        svg {
          min-width: 24px;
        }

        &:nth-of-type(1),
        &:nth-of-type(2) {
          color: ${
            isDark ? theme.colors.secondary.main : theme.colors.base.lighter
          };

          svg {
            margin-right: 4px;
            path {
              fill: ${
                isDark ? theme.colors.secondary.main : theme.colors.base.lighter
              };
            }
          }
          &:hover {
            color: ${
              isDark ? theme.colors.secondary.light : theme.colors.primary.main
            };
            svg {
              path {
                fill: ${
                  isDark
                    ? theme.colors.secondary.light
                    : theme.colors.primary.main
                };
              }
            }
          }
          &:active {
            color: ${
              isDark ? theme.colors.secondary.dark : theme.colors.primary.dark
            };
            svg {
              path {
                fill: ${
                  isDark
                    ? theme.colors.secondary.dark
                    : theme.colors.primary.dark
                };
              }
            }
          }
          &:disabled {
            color: ${
              isDark
                ? theme.colors.gray['main-dark-mode']
                : theme.colors.gray.light
            };
            svg {
              path {
                fill: ${
                  isDark
                    ? theme.colors.gray['main-dark-mode']
                    : theme.colors.gray.light
                };
              }
            }
          }
        }
        &:nth-of-type(1) {
          &::after {
            content: 'Anterior';
          }
        }
        &:nth-of-type(2) {
          &::before {
            content: 'Siguiente';
          }
        }
      }
    }
  `,
);
